import Collapsible from "@components/collapsible";
import * as React from 'react';
export default {
  Collapsible,
  React
};